export default __webpack_public_path__ + "static/media/logo100.d47f0a94.png";